module.exports = __webpack_public_path__ + "img/main_btn02.6dceb9e2.jpg";